import type { ParamMatcher } from "@sveltejs/kit";

export const match: ParamMatcher = (param) => {
  return ["functions", "sandboxes"].includes(param);
};
